import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import { adminImage } from "../../constants/Variables";
import { setSelectedChat } from "../../lib/slices/selectedChatSlice";
import { fetchAllEvents } from "../../services/appointments";
import { getAdminDetail } from "../../services/Auth";
import { convertAndCreateDate } from "../../utils";
import Loader from "../Loader";
import SnackbarAlert from "../SnackBar";
import AllChats from "./AllChats";

const style = {
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      backgroundColor: "#F3F3F3",
      "& .MuiOutlinedInput-notchedOutline": {
        border: `none`,
        boxShadow: "none",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `none`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `none`,
      },
    },
  },
};

function AllUsers() {
  const dispatch = useDispatch();
  const [allEvents, setAllEvents] = useState([]);
  const [filteredEvent, setFilteredEvent] = useState([]);
  const [searchVall, setSearchVall] = useState("");
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [adminDetails, setAdminDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    if (selectedBranch?.length > 0) {
      handleFetchAllEvents();
    }
    fetchAdminDetail();
  }, [selectedBranch]);

  useEffect(() => {
    const filtered = allEvents.filter((appointment) => {
      const idMatch = appointment?.appointmentId
        ?.toLowerCase()
        .includes(searchVall.toLowerCase());
      const userMatch = appointment?.user?.username
        ?.toLowerCase()
        .includes(searchVall.toLowerCase());
      return idMatch || userMatch;
    });
    setFilteredEvent(filtered);
  }, [allEvents, searchVall]);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const fetchAdminDetail = async () => {
    try {
      setIsLoading(true);
      const ress = await getAdminDetail();
      if (ress.status === 200 || ress.status === 201) {
        setIsLoading(false);
        const data = ress?.data?.data.adminDetails;
        let payload = {
          ...data,
          image: adminImage,
          type: "admin",
        };
        setAdminDetails(payload);
        localStorage.setItem("selectedUser", JSON.stringify(payload));
        dispatch(setSelectedChat(payload));
      } else {
        setIsLoading(false);
        handleSnackbarVal(true, "error", ress?.data?.message);
      }
    } catch (error) {
      console.log(error, "errorerrorerror");
    }
  };

  const handleFetchAllEvents = async () => {
    try {
      setIsLoading(true);
      const response = await fetchAllEvents(selectedBranch[0]);
      setIsLoading(false);

      if (response.status === 200 || response.status === 201) {
        let data = response?.data?.data;

        let formattedData = data.map((item) => ({
          ...item,
          start: convertAndCreateDate(item.start),
          end: convertAndCreateDate(item.end),
        }));

        let uniqueAppointments = [];
        let uniqueUser = [];
        let appointmentIds = new Set();
        let userIds = new Set();

        formattedData.forEach((item) => {
          if (item.status !== "Cancelled" && item.status !== "Completed") {
            if (!appointmentIds.has(item.appointmentId)) {
              appointmentIds.add(item.appointmentId);
              uniqueAppointments.push(item);
            }
          }
        });
        if (uniqueAppointments) {
          uniqueAppointments.forEach((item) => {
            if (!userIds.has(item.user?._id)) {
              userIds.add(item.user?._id);
              uniqueUser.push(item);
            }
          });
        }
        setAllEvents(uniqueUser);
      } else {
        handleSnackbarVal(true, "error", response?.data?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleFetchAllEvents ~ error:", error);
      handleSnackbarVal(true, "error", error?.message);
    }
  };

  const handleChatWidt = (item) => {
    if (item.type == "admin") {
      localStorage.setItem("selectedUser", JSON.stringify(item));
      dispatch(setSelectedChat(item));
    } else {
      localStorage.setItem("selectedUser", JSON.stringify(item?.user));
      dispatch(setSelectedChat(item?.user));
    }
  };

  return (
    <Paper sx={{ p: 2, borderRadius: "10px" }}>
      <Stack gap={1.5} direction={"row"} alignItems={"center"}>
        <img
          src={allIcons.handshakeInactiveIcon}
          alt="handshake-icon"
          width={30}
        />
        <Stack direction={"row"} alignItems={"center"}>
          <Typography variant="h1" fontSize={"1.125rem"} fontWeight={"bold"}>
            Messages
          </Typography>
          <ExpandMoreIcon />
        </Stack>
      </Stack>
      <Box my={3}>
        <TextField
          variant="outlined"
          sx={style.searchField}
          fullWidth
          value={searchVall}
          onChange={(e) => {
            setSearchVall(e.target.value);
          }}
          placeholder="search message"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Typography
        variant="body2"
        mb={2}
        fontSize={"0.99rem"}
        fontFamily={"Metropolis"}
      >
        Admin Chat
      </Typography>
      <Stack
        onClick={() => handleChatWidt(adminDetails)}
        p={"8px 8px"}
        borderRadius={2}
        direction={"row"}
        justifyContent={"space-between"}
        bgcolor={"#615EF00F"}
        sx={{
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "#F3F3F3",
          },
        }}
      >
        <Stack gap={2} direction={"row"} alignItems={"center"}>
          <Box borderRadius={100} overflow={"hidden"} width={48} height={48}>
            <img
              src={
                "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?size=338&ext=jpg&ga=GA1.1.2008272138.1728345600&semt=ais_hybrid"
              }
              alt="image"
              width={"100%"}
              height={"100%"}
            />
          </Box>

          <Stack>
            <Typography
              variant="body1"
              fontSize={"0.875rem"}
              fontWeight={"bold"}
              fontFamily={"Metropolis"}
            >
              Admin
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Typography
        variant="body2"
        mt={2}
        fontSize={"0.9rem"}
        fontFamily={"Metropolis"}
      >
        User's Chat
      </Typography>
      <Stack
        gap={1.5}
        height={"40vh"}
        overflow={"auto"}
        mt={1}
        sx={{
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "orange",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#FF9900",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#F3F3F3",
            borderRadius: "10px",
          },
        }}
      >
        {filteredEvent?.length > 0 ? (
          <>
            {filteredEvent?.map((item, index) => {
              return (
                <AllChats
                  item={item}
                  index={index}
                  handleChatWidt={handleChatWidt}
                />
              );
            })}
          </>
        ) : (
          <Typography
            variant="h1"
            fontSize={14}
            textAlign={"center"}
            color={appcolors.black}
            mt={1}
          >
            No User Found!
          </Typography>
        )}
      </Stack>

      <Loader isLoading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </Paper>
  );
}

export default AllUsers;
